module.exports = __webpack_public_path__ + "img/supply-flow-md.76e33476.svg";